<template>
  <v-card class="vacation-accept">
    <v-subheader>
      <v-icon medium color="cyan darken-3" class="mr-2">self_improvement</v-icon>
      <span class="ml-2">Неделя отдыха от ревью :)</span>
    </v-subheader>
<!--    <v-layout row>-->
<!--      <v-flex>-->
<!--        <v-card tile flat class="grey lighten-4">-->
<!--          <v-card-text>-->
<!--            <span class="font-weight-medium">Инфо: </span>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--      </v-flex>-->
<!--    </v-layout>-->
  </v-card>
</template>

<script>
  export default {
    name: "VacationAccept",
    props: ["date", "description", "level", "message"]
  }
</script>

<style scoped>
  .vacation-accept {
    border: 1px solid #78909C;
  }

</style>
